import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import BookNow from "@/pages/BookNow";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/book" element={<BookNow />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
